import { getCurrentUser } from '@/utils/auth'

const defaults = () => ({ hideCanceled: false, hideMapVehicles: false })

export async function loadWaybillPreferences() {
  const user = await getCurrentUser()
  const key = `waybill-preferences:${user.id}`
  const saved = window.localStorage.getItem(key)
  let value
  try { value = saved ? JSON.parse(saved) : {} } catch (error) { value = {} }
  return { key, value: { hideCanceled: value.hideCanceled === true, hideMapVehicles: value.hideMapVehicles === true } }
}

export function saveWaybillPreferences(key, value) {
  if (!key) throw new Error('当前账号设置未加载，请稍后重试')
  const prefs = { ...defaults(), hideCanceled: value.hideCanceled === true, hideMapVehicles: value.hideMapVehicles === true }
  window.localStorage.setItem(key, JSON.stringify(prefs))
  window.dispatchEvent(new CustomEvent('waybill-preferences-changed', { detail: prefs }))
}
